export const name = 'TARGET_SEQUENCE.render';
// 默认显示模板
function renderDefault(h, renderOpts, params) {
    const { row, column } = params;
    return [<span class="my-link"> {row[column.property]} </span>];
}
// 导出模板，例如导出插槽中自定义的内容
function exportMethod(params) {
    return '自定义内容';
}
export default {
    renderDefault,
    exportMethod,
};
